/* Pushantigallery V3 — Ivory Editorial | theme.js */
(function () {
  'use strict';

  /* ---------------- reveal ---------------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  function watchAll() {
    document.querySelectorAll('.rv,.op,.state h2,.bandsplit,.pw,.salone .it,.m1').forEach(function (el) { io.observe(el); });
  }

  /* ---------------- split parole ---------------- */
  function splitWords() {
    document.querySelectorAll('[data-split]').forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function (w) { return '<span class="w"><span>' + w + '</span></span>'; }).join(' ');
      Array.prototype.forEach.call(el.querySelectorAll('.w>span'), function (s, i) {
        s.style.transitionDelay = (i * 0.03).toFixed(2) + 's';
      });
      io.observe(el);
    });
  }

  /* ---------------- hero ---------------- */
  function heroIn() {
    document.querySelectorAll('h1.mega .ln>span').forEach(function (s, i) {
      s.style.transition = 'transform 1.25s cubic-bezier(.16,1,.3,1)';
      s.style.transitionDelay = (0.15 + i * 0.12) + 's';
      requestAnimationFrame(function () { s.style.transform = 'translateY(0)'; });
    });
  }
  function curtain() {
    var cu = document.querySelector('.curtain');
    if (!cu) { heroIn(); return; }
    setTimeout(function () { cu.classList.add('up'); heroIn(); }, 1400);
    setTimeout(function () { if (cu.parentNode) cu.parentNode.removeChild(cu); }, 2700);
  }

  /* ---------------- scroll engine ---------------- */
  function scrollEngine() {
    var pars = [].slice.call(document.querySelectorAll('[data-par]'));
    var prog = document.querySelector('.prog');
    var nav = document.querySelector('nav.n');
    var sal = document.querySelector('.salone');
    var track = sal ? sal.querySelector('.tr') : null;
    var ticking = false;
    function isMob() { return window.innerWidth <= 780; }
    function sizeSalone() {
      if (!sal || !track) return;
      if (isMob()) { sal.style.height = 'auto'; track.style.transform = 'none'; return; }
      var dist = Math.max(0, track.scrollWidth - window.innerWidth);
      sal.style.height = (window.innerHeight + dist * 1.05) + 'px';
    }
    function frame() {
      var y = window.scrollY;
      if (prog) prog.style.width = (y / Math.max(1, document.body.scrollHeight - window.innerHeight) * 100) + '%';
      if (nav) nav.classList.toggle('stuck', y > 120 || !document.querySelector('.hero'));
      pars.forEach(function (el) {
        var host = el.closest('[data-par-host]') || el.parentElement;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * parseFloat(el.dataset.par);
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      if (sal && track && !isMob()) {
        var dist = Math.max(0, track.scrollWidth - window.innerWidth);
        var rr = sal.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -rr.top / (sal.offsetHeight - window.innerHeight || 1)));
        track.style.transform = 'translate3d(' + (-(p * dist)).toFixed(1) + 'px,0,0)';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { sizeSalone(); frame(); });
    window.addEventListener('load', function () { sizeSalone(); frame(); });
    sizeSalone(); frame();
  }

  /* ---------------- cursore ---------------- */
  function cursor() {
    if (!document.body.dataset.cursor) return;
    if (window.matchMedia('(hover:none)').matches || window.innerWidth <= 780) return;
    var c = document.createElement('div'); c.className = 'cur'; document.body.appendChild(c);
    var x = window.innerWidth / 2, y = window.innerHeight / 2, cx = x, cy = y;
    window.addEventListener('mousemove', function (e) { x = e.clientX; y = e.clientY; });
    (function loop() {
      cx += (x - cx) * 0.18; cy += (y - cy) * 0.18;
      c.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      c.classList.toggle('big', !!e.target.closest('a,button,.pw,.bandsplit,.salone .it,input'));
    });
  }

  /* ---------------- toast ---------------- */
  function toast(html) {
    var t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('data-testid', 'toast'); document.body.appendChild(t); }
    t.innerHTML = html;
    requestAnimationFrame(function () { t.classList.add('on'); });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('on'); }, 5200);
  }

  /* ---------------- nav ---------------- */
  function navUI() {
    var drop = document.querySelector('.drop');
    if (drop) {
      var trigger = drop.querySelector('[data-drop-trigger]');
      if (trigger) trigger.addEventListener('click', function () { drop.classList.toggle('open'); });
      document.addEventListener('click', function (e) { if (!drop.contains(e.target)) drop.classList.remove('open'); });
    }
    var burger = document.querySelector('.bg');
    var mnav = document.getElementById('mnav');
    if (burger && mnav) {
      burger.addEventListener('click', function () { mnav.classList.add('on'); });
      var x = mnav.querySelector('.x');
      if (x) x.addEventListener('click', function (e) { e.preventDefault(); mnav.classList.remove('on'); });
    }
  }

  /* ---------------- carrello ---------------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () { });
  }
  function addToCart(id, qty, name) {
    var btn = document.querySelector('[data-add-to-cart]');
    if (btn) { btn.classList.add('loading'); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('loading');
        if (!res.ok) { toast('<b>Non è stato possibile aggiungere l\'opera</b><br>' + (res.d.description || res.d.message || '')); return; }
        refreshCart();
        toast('<b>Aggiunta al carrello</b><br>' + qty + ' × ' + name + '<br><a href="/cart">Vai al carrello →</a>');
      }).catch(function () {
        if (btn) btn.classList.remove('loading');
        toast('<b>Errore di rete</b><br>Riprova tra qualche istante.');
      });
  }

  /* ---------------- scheda prodotto ---------------- */
  function productForm() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var dataEl = document.getElementById('product-json');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceBox = root.querySelector('[data-price]');
    var stockBox = root.querySelector('[data-stock]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyBtn = root.querySelector('[data-buy-now]');
    var qtyVal = root.querySelector('[data-qty-value]');
    var selected = [];

    function fmt(cents) {
      var v = (cents / 100).toFixed(2).split('.');
      return '€ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
    }
    function currentSelection() {
      return [].slice.call(root.querySelectorAll('[data-opt-value].on')).map(function (b) { return b.dataset.value; });
    }
    function matchVariant(sel) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function valueAvailable(optIndex, value) {
      return product.variants.some(function (v) { return v.options[optIndex] === value && v.available; });
    }
    function setMedia(variant) {
      if (!variant || !variant.featured_image) return;
      var fi = variant.featured_image;
      var hit = root.querySelector('[data-thumb][data-media-id="' + fi.id + '"]');
      if (hit) { hit.click(); return; }
      var main = root.querySelector('[data-main-image]');
      if (main) {
        main.src = fi.src;
        var wrap = main.closest('.gmain');
        if (wrap && fi.width && fi.height) wrap.style.setProperty('--ar', fi.width + '/' + fi.height);
      }
    }
    function render() {
      selected = currentSelection();
      var v = matchVariant(selected) || product.variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceBox) {
        var html = fmt(v.price);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s>' + fmt(v.compare_at_price) + '</s><span class="off">-' +
            Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>';
        }
        priceBox.innerHTML = html;
      }
      if (stockBox) {
        stockBox.className = 'stock' + (v.available ? '' : ' out');
        stockBox.innerHTML = '<i></i>' + (v.available ? 'Disponibile' : 'Esaurito');
      }
      [addBtn, buyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !v.available;
        b.classList.toggle('is-disabled', !v.available);
      });
      if (addBtn) addBtn.querySelector('span').textContent = v.available ? 'Aggiungi al carrello' : 'Esaurito';
      root.querySelectorAll('[data-opt-value]').forEach(function (b) {
        var oi = parseInt(b.dataset.index, 10);
        var av = valueAvailable(oi, b.dataset.value);
        b.classList.toggle('so', !av);
        b.disabled = !av;
      });
      root.querySelectorAll('[data-opt-selected]').forEach(function (el) {
        el.textContent = selected[parseInt(el.dataset.optSelected, 10)] || '';
      });
      setMedia(v);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({ variant: v.id }, '', url);
      return v;
    }

    root.querySelectorAll('[data-opt-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var oi = b.dataset.index;
        root.querySelectorAll('[data-opt-value][data-index="' + oi + '"]').forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        render();
      });
    });

    /* galleria */
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = root.querySelector('[data-main-image]');
        var wrap = main ? main.closest('.gmain') : null;
        if (main) main.src = t.dataset.src;
        if (wrap && t.dataset.ar) wrap.style.setProperty('--ar', t.dataset.ar);
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    /* quantità */
    var q = 1;
    function setQ(n) {
      q = Math.max(1, Math.min(20, n));
      if (qtyVal) qtyVal.textContent = q;
      var qi = root.querySelector('[data-qty-input]');
      if (qi) qi.value = q;
    }
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { setQ(q - 1); });
    if (plus) plus.addEventListener('click', function () { setQ(q + 1); });

    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var v = matchVariant(currentSelection()) || product.variants[0];
      if (!v || !v.available) return;
      addToCart(v.id, q, product.title);
    });

    render();
  }

  /* ---------------- boot ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    watchAll(); splitWords(); navUI(); cursor(); scrollEngine(); productForm(); refreshCart();
    document.querySelectorAll('[data-cart-toast]').forEach(function (el) {
      el.addEventListener('click', function () { });
    });
  });
  window.addEventListener('load', curtain);
  document.addEventListener('shopify:section:load', function () { watchAll(); navUI(); productForm(); });
})();
